"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pick = void 0;
const record_js_1 = require("./record.js");
const reduceKey_js_1 = require("./reduceKey.js");
function pick(subject, ...props) {
    return (0, reduceKey_js_1.reduceByKey)(subject, (p, k) => {
        if (props.indexOf(k) >= 0)
            p[k] = subject[k];
        return p;
    }, Object.getPrototypeOf(subject) === null ? (0, record_js_1.record)() : {});
}
exports.pick = pick;
//# sourceMappingURL=pick.js.map